import api from './api';

export interface Project {
  id: string;
  user_id: string;
  name: string;
  description?: string;
  topic: 'ML' | 'CV' | 'QC' | 'QML' | 'Backend' | 'Integrated';
  difficulty: 'Beginner' | 'Intermediate' | 'Advanced';
  status: 'Planning' | 'In Progress' | 'Complete' | 'Published';
  start_date?: string;
  end_date?: string;
  hours_spent: number;
  github_link?: string;
  live_link?: string;
  tech_stack: string[];
  created_at: string;
  updated_at?: string;
}

export interface CreateProjectData {
  name: string;
  description?: string;
  topic: 'ML' | 'CV' | 'QC' | 'QML' | 'Backend' | 'Integrated';
  difficulty?: 'Beginner' | 'Intermediate' | 'Advanced';
  status?: 'Planning' | 'In Progress' | 'Complete' | 'Published';
  start_date?: string;
  end_date?: string;
  github_link?: string;
  live_link?: string;
  tech_stack?: string[];
}

export const projectsService = {
  async getAll(status?: string, topic?: string): Promise<Project[]> {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (topic) params.append('topic', topic);
    
    const response = await api.get(`/api/projects?${params.toString()}`);
    return response.data;
  },

  async getById(id: string): Promise<Project> {
    const response = await api.get(`/api/projects/${id}`);
    return response.data;
  },

  async create(data: CreateProjectData): Promise<Project> {
    const response = await api.post('/api/projects', data);
    return response.data;
  },

  async update(id: string, data: Partial<Project>): Promise<Project> {
    const response = await api.patch(`/api/projects/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/projects/${id}`);
  },
};

